export default class RegistrationNumber {
  private readonly _value: string;
  constructor(value: string) {
    this._value = value;
  }
  public get value(): string {
    return this._value;
  }
  public static fromJSON(value: string): RegistrationNumber | undefined {
    if (!value || value === '') return;
    return new RegistrationNumber(value);
  }

  public toJSON(): string {
    return this._value;
  }
}
